import { render, staticRenderFns } from "./RegisterDevice.vue?vue&type=template&id=61ba6a80"
import script from "./RegisterDevice.vue?vue&type=script&lang=js"
export * from "./RegisterDevice.vue?vue&type=script&lang=js"
import style0 from "./RegisterDevice.vue?vue&type=style&index=0&id=61ba6a80&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports